import translate from '@/lib/intl/translate';
import { I18nBreak } from '@/modules/I18n';
import type MatchingTableHeader from '../types/MatchingTableHeader';
import MatchingHeaderCategory from './MatchingHeaderCategory';

/**
 * This object is based off of the confluence doc and is subject to
 * be changed when the API contract for matching headers has been
 * finalized.
 */
const MatchingTableHeaders: MatchingTableHeader[] = [
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'address line 1',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_ADDRESS_LINE_1'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'address line 2',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_ADDRESS_LINE_2'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'amount of time',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_AMOUNT_TIME'),
      tooltip: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_AMOUNT_TIME_TOOLTIP'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'assignee emails',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_ASSIGNEE'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_ASSIGNEE'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'bio',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_BIO'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_NAME'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign start date',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_START_DATE'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign description',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_DESCRIPTION'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'category',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CATEGORY'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_CATEGORY', { br: I18nBreak }),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'city',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CITY'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent first name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_FIRST_NAME'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent label',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_LABEL'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_LABEL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent last name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_LAST_NAME'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent organization name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_ORG_NAME'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'contribution amount',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_AMOUNT'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_AMOUNT'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'contribution label',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_LABEL'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_LABEL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'country',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_COUNTRY'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'date',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DATE'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_DATE'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'dob',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DOB'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_DOB'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'due date',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DUE_DATE'),
      tooltip: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DUE_DATE_TOOLTIP'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'earned revenue amount',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EARNED_REV_AMT'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'email business primary',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_BIZ_PRIMARY'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_EMAIL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'email business',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_BIZ'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_EMAIL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'email personal primary',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_PERSONAL_PRIMARY'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_EMAIL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'email personal',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EMAIL_PERSONAL'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_EMAIL'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'payment type',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PAYMENT_TYPE'),
      tooltip: translate(
        'DATA_UPLOADS_MATCH_TABLE_HEADER_PAYMENT_TYPE_TOOLTIP',
      ),
    },
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'end date',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_END_DATE'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'estimated value amount',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_EST_VALUE_AMT'),
      tooltip: translate(
        'DATA_UPLOADS_MATCH_TABLE_HEADER_EST_VALUE_AMT_TOOLTIP',
        {
          br: I18nBreak,
        },
      ),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'facebook profile',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_FACEBOOK_PROFILE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'fax number',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_FAX_NUMBER'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'frequency',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_FREQUENCY'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_FREQUENCY', {
        br: I18nBreak,
      }),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'full address',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_FULL_ADDRESS'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'grant amount',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_GRANT_AMOUNT'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'grant name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_GRANT_NAME'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'goal amount',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_GOAL_AMOUNT'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign id',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_ID'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_CAMPAIGN_ID'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent id',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_ID'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_CONSTITUENT_ID'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'contribution id',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_ID'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_CONTRIBUTION_ID'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'instagram profile',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_INSTAGRAM_PROFILE'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'item donated',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_ITEM_DONATED'),
      tooltip: translate(
        'DATA_UPLOADS_MATCH_TABLE_HEADER_ITEM_DONATED_TOOLTIP',
      ),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'lifecycle board column',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_LIFECYCLE_BOARD_COLUMN'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'lifecycle board',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_LIFECYCLE_BOARD'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'linkedin profile',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_LINKED_PROFILE'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'notes',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_NOTE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone business',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_BIZ'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone home',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_HOME'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone mobile',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_MOBILE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone number primary',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_NUMBER_PRIMARY'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone number',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_NUMBER'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_PHONE_NUMBER'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone primary business',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_BIZ'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone primary home',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_HOME'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'phone primary mobile',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PHONE_PRIMARY_MOBILE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'prefix',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PREFIX'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'pronouns',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PRONOUNS'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'quantity',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_QUANTIFY'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_QUANTITY'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'restriction area',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_RESTRICTION_AREA'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'soft credit',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_SOFT_CREDIT'),
      tooltip: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_SOFT_CREDIT_TOOLTIP'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'constituent source',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_SOURCE'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_SOURCE'),
    },
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign source',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_SOURCE'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_SOURCE'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'contribution source',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONTRIBUTION_SOURCE'),
      tooltip: translate('DATA_UPLOADS_TOOLTIP_SOURCE'),
    },
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'sponsorship amount',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_SPONSORSHIP_AMOUNT'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'recurring plan start date',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_START_DATE'),
      tooltip: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_START_DATE_TOOLTIP'),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'state',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_STATE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'twitter handle',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_TWITTER_HANDLE'),
  },
  {
    category: MatchingHeaderCategory.CAMPAIGN,
    fieldName: 'campaign website',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CAMPAIGN_WEBSITE'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'unit',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_UNIT'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'url',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_CONSTITUENT_WEBSITE'),
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'zip',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_ZIP'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'dedicated to (name)',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_NAME'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'dedicated to (email)',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_EMAIL'),
  },
  {
    category: MatchingHeaderCategory.CONTRIBUTON,
    fieldName: 'dedication type',
    label: {
      text: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_TYPE'),
      tooltip: translate(
        'DATA_UPLOADS_MATCH_TABLE_HEADER_DEDICATION_TYPE_TOOLTIP',
      ),
    },
  },
  {
    category: MatchingHeaderCategory.CONSTITUENT,
    fieldName: 'preferred first name',
    label: translate('DATA_UPLOADS_MATCH_TABLE_HEADER_PREFERRED_FIRST_NAME'),
  },
].sort((a, b) => a.category.localeCompare(b.category));

export default MatchingTableHeaders;
